import { render, staticRenderFns } from "./MetaboliteView.vue?vue&type=template&id=085fdef7&scoped=true&"
import script from "./MetaboliteView.vue?vue&type=script&lang=js&"
export * from "./MetaboliteView.vue?vue&type=script&lang=js&"
import style0 from "./MetaboliteView.vue?vue&type=style&index=0&id=085fdef7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fdef7",
  null
  
)

export default component.exports